<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        COD Payment Pending
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-data-table
      :headers="headers"
      :items="formattedData"
      :loading="orderListLoader"
      class="elevation-1 custom-icon-size mt-7"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-form>
          <v-row class="custom-row pl-5 pr-5">
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="client_name"
                :items="clients"
                outlined
                dense
                chips
                item-text="name"
                item-value="id"
                small-chips
                label="Client name"
                clearable
                @focus="fetchClients"
                @click:clear="clearInput('this.client_name')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="carrier"
                :items="carriers"
                outlined
                dense
                chips
                item-text="name"
                item-value="id"
                small-chips
                label="Carrier name"
                clearable
                @click:clear="clearInput('this.carrier')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="country"
                :items="countries"
                outlined
                dense
                chips
                item-text="name"
                item-value="id"
                small-chips
                label="Country"
                clearable
                @click:clear="clearInput('this.country')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(from_date)"
                    label="From Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    @click:clear="clearDateInput('this.from_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="from_date"
                  @input="dateMenu = false"
                  :max="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(to_date)"
                    label="To Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    @click:clear="clearDateInput('this.to_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="to_date"
                  @input="dateMenuTo = false"
                  :max="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="9"
              class="text-end pr-4 mb-2"
              :sm="userCategory.user_category == 3 ? '9' : '12'"
            >
              <v-btn class="mt-0 success" color="primary" @click="searchAll"
                >Search</v-btn
              >
              <v-btn color="white" class="mt-0 ml-4" @click="allClear"
                >Clear</v-btn
              >
            </v-col>
          </v-row>
          <v-divider class="mt-2 mb-2"></v-divider>
        </v-form>
      </template>
      <template v-slot:[`item.carrier_cod_amount`]="{ item }">
        {{ changeFormat(item.carrier_cod_amount) }} (#{{
          item.carrier_order_pending
        }}) <br />
        <v-icon
          @click="openDetails(item, 'carrier')"
          v-if="item.carrier_order_pending > 0"
          >mdi-eye-outline</v-icon
        >
      </template>
      <template v-slot:[`item.rsa_cod_amount`]="{ item }">
        {{ changeFormat(item.rsa_cod_amount) }} (#{{ item.rsa_order_pending }})
        <br />
        <v-icon
          v-if="item.rsa_order_pending > 0"
          @click="openDetails(item, 'rsa')"
          >mdi-eye-outline</v-icon
        >
      </template>
      <template v-slot:[`item.date`]="{ item }">
        {{ convertMonth(item.date) }}
      </template>
      <template v-slot:body="{ items }">
        <tbody v-for="(item, index) in items" :key="index" class="custom-table">
          <tr v-if="item.isDate" style="background-color: #add8e645">
            <td>
              <b>{{ convertMonth(item.date) }}</b>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <span v-for="(e, i) in item.currency" :key="e"
                ><b>{{ i }} - {{ changeFormat(e) }}</b
                ><br
              /></span>
            </td>
            <td>
              <span v-for="(e, i) in item.rsa" :key="e"
                ><b>{{ i }} - {{ changeFormat(e) }}</b
                ><br
              /></span>
            </td>
          </tr>
          <tr v-else>
            <td v-for="(header, headerIndex) in headers" :key="headerIndex">
              <span v-if="header.value == 'carrier_cod_amount'">
                <v-icon
                  @click="openDetails(item, 'carrier')"
                  v-if="item['carrier_order_pending'] > 0"
                  >mdi-card-search-outline</v-icon
                >
                <label v-if="item[header.value] > 0">
                  {{ changeFormat(item[header.value]) }} (#{{
                    item["carrier_order_pending"]
                  }})
                </label>
                <label v-else>--</label>
              </span>
              <span v-else-if="header.value == 'rsa_cod_amount'">
                <v-icon
                  @click="openDetails(item, 'rsa')"
                  v-if="item['rsa_order_pending'] > 0"
                  >mdi-card-search-outline</v-icon
                >
                <label v-if="item[header.value] > 0">
                  {{ changeFormat(item[header.value]) }} (#{{
                    item["rsa_order_pending"]
                  }})
                </label>
                <label v-else>--</label>
              </span>
              <span v-else> {{ item[header.value] }}</span>
            </td>
          </tr>
        </tbody>
        <tr style="background-color: #ffdab973">
          <td class="pl-3"><b class="pt-6">Total</b></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="pl-3">
            <span v-for="(e, i) in currency_wise_total.rsa" :key="e"
              ><b>{{ i }} - {{ changeFormat(e) }}</b
              ><br
            /></span>
          </td>
          <td class="pl-3">
            <span v-for="(e, i) in currency_wise_total.carrier" :key="e"
              ><b>{{ i }} - {{ changeFormat(e) }}</b
              ><br
            /></span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  data: () => ({
    formattedData: [],
    clients: [],
    countries: [],
    carriers: [],
    dateMenu: false,
    from_date: "",
    to_date: "",
    dateMenuTo: false,
    apiResponse: {},
    headers: [
      {
        text: "Carrier",
        value: "carrier_name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Client Name",
        value: "client_name",
        class: "body-1 font-weight-bold",
        sortable: false,
        align: "left",
      },
      {
        text: "Country",
        value: "country_name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "COD Currency",
        value: "cod_currency",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "COD Amount Pending By Carrier (Total Orders #)",
        value: "carrier_cod_amount",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "COD Amount Pending By RSA (Total Orders #)",
        value: "rsa_cod_amount",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    options: {},
    total: 0,
    orderListLoader: false,
    filtersArr: [],
    orderList: [],
    client_name: null,
    carrier: null,
    country: null,
  }),

  created() {
    this.fetchClients();
    this.fetchCarriers();
    this.getCountryList();
    this.fetchOrderList();
  },
  methods: {
    ...mapActions([
      "pendingCodList",
      "fetchClient",
      "getCarriersDropdown",
      "getCountries",
    ]),

    convertMonth(inputDate) {
      const [month, year] = inputDate.split("-");
      const monthMap = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dec",
      };
      const abbreviatedMonth = monthMap[month];
      const convertedDate = `${abbreviatedMonth} - ${year}`;
      return convertedDate;
    },
    clearDateInput(type) {
      if (type == "this.to_date") {
        this.to_date = "";
      } else {
        this.from_date = "";
      }
    },
    getCountryList() {
      this.getCountries().then((res) => {
        this.countries = res.data;
      });
    },
    fetchCarriers() {
      this.getCarriersDropdown({
        pagination: 0,
        active: "all",
      })
        .then((res) => {
          this.carriers = res.data;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    fetchClients() {
      if (this.clients.length == 0)
        this.fetchClient({
          service: "clickdna,fulfillment_wid_last_mile",
        }).then((res) => {
          this.clients = res.data;
        });
    },
    clearInput(val) {
      if (val) {
        val = null;
      }
    },
    getDaysInMonth(year, month) {
      // Months are zero-based in JavaScript, so January is 0 and December is 11
      return new Date(year, month + 1, 0).getDate();
    },
    openDetails(item, type) {
      const parts = item.date.split("-");
      let year = parseInt(parts[1]);
      let month = parseInt(parts[0]) - 1; // Months are zero-based in JavaScript
      const daysInMonth = this.getDaysInMonth(year, month);
      var todate = "";
      var fromdate = "";
      let months = month + 1;
      if (months < 9) {
        months = "0" + months;
      }
      if (daysInMonth == 31) {
        fromdate = `${year}-${months}-01`;
        todate = `${year}-${months}-31`;
      } else if (daysInMonth == 30) {
        fromdate = `${year}-${months}-01`;
        todate = `${year}-${months}-30`;
      } else if (daysInMonth == 28) {
        fromdate = `${year}-${months}-01`;
        todate = `${year}-${months}-28`;
      } else if (daysInMonth == 29) {
        fromdate = `${year}-${months}-01`;
        todate = `${year}-${months}-29`;
      }

      window.open(
        this.$router.resolve({
          name: "PendingOrderList",
          query: {
            client_id: item.client_id,
            from_date: fromdate,
            to_date: todate,
            carrier_id: item.carrier_id,
            destination_country_id: item.destination_country_id,
            type: type,
          },
        }).href,
        "_blank"
      );
    },
    allFilters() {
      this.loader = true;
      let obj = {
        carrier: this.carrier,
        client: this.client_name,
        country: this.country,
        from_date: this.from_date,
        to_date: this.to_date,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.orderListLoader = true;

      this.pendingCodList({ ...this.options, ...this.filtersArr })
        .then((res) => {
          this.orderListLoader = false;
          this.orderList = res.data.records;
          this.currency_wise_total = res.data.currency_wise_total;

          const formattedData = [];

          for (const [date, records] of Object.entries(res.data.records)) {
            // Add the date row
            formattedData.push({ isDate: true, date });
            for (const record of records.data) {
              // Add the value row
              formattedData.push({
                isDate: false,
                carrier_name: record.carrier_name,
                client_name: record.client_name,
                cod_currency: record.cod_currency,
                country_name: record.country_name,
                carrier_order_pending: record.carrier_order_pending,
                carrier_cod_amount: record.carrier_cod_amount,
                rsa_order_pending: record.rsa_order_pending,
                rsa_cod_amount: record.rsa_cod_amount,
                carrier_id: record.carrier_id,
                destination_country_id: record.destination_country_id,
                client_id: record.client_id,
                date: record.date,
              });
            }
          }

          this.formattedData = formattedData;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    clear() {
      this.carrier = null;
      this.client_name = null;
      this.country = null;
      this.from_date = null;
      this.to_date = null;
    },
    async allClear() {
      await this.clear();
      this.filtersArr = {};
      await this.fetchOrderList();
    },
    async fetchOrderList() {
      this.orderList = [];
      this.orderListLoader = true;
      await this.pendingCodList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.orderList = res.data.records;
          this.currency_wise_total = res.data.currency_wise_total;
          const formattedData = [];

          this.orderListLoader = true;

          for (const [date, records] of Object.entries(res.data.records)) {
            // Add the date row
            var currency = records["carrier_total"];
            var rsa = records["rsa_total"];
            formattedData.push({ isDate: true, date, currency, rsa });
            for (const record of records.data) {
              // Add the value row

              formattedData.push({
                isDate: false,
                carrier_name: record.carrier_name,
                client_name: record.client_name,
                cod_currency: record.cod_currency,
                country_name: record.country_name,
                carrier_order_pending: record.carrier_order_pending,
                carrier_cod_amount: record.carrier_cod_amount,
                rsa_order_pending: record.rsa_order_pending,
                rsa_cod_amount: record.rsa_cod_amount,
                carrier_id: record.carrier_id,
                destination_country_id: record.destination_country_id,
                client_id: record.client_id,
                date: record.date,
              });
            }
            this.orderListLoader = false;
          }

          this.formattedData = formattedData;
          this.total = res.data.total;
        })
        .catch(() => {
          this.orderListLoader = false;
        });
    },
  },
};
</script>
<style>
tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}
.theme--light.v-data-table {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
}
.v-data-table {
  line-height: 1.5;
  max-width: 100%;
}
.custom-table {
  border-collapse: collapse;
  width: 100%;
  font-size: 14px;
  table-layout: fixed; /* Set table layout to fixed */
}

.custom-table th,
.custom-table td {
  padding: 8px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  width: calc(
    100% / 8
  ); /* Set the width for each column based on the number of headers (8 in this case) */
}

.custom-table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

.custom-table tbody tr:hover {
  background-color: #f9f9f9;
}

.custom-table tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.custom-table tbody tr:last-child {
  border-bottom: 2px solid #e0e0e0;
}

.custom-table tbody td:first-child {
  white-space: nowrap;
}

.custom-table tbody td:last-child {
  text-align: right;
}
.v-text-field__details {
  display: none !important;
  flex: 1 0 auto;
  max-width: 100%;
  min-height: 14px;
  overflow: hidden;
}
.custom-row .v-text-field input {
  flex: 1 1 auto;
  line-height: 20px;
  /* padding: 24px 0 8px; */
  max-width: 100%;
  min-width: 0px;
  width: 100%;
}
</style>
